<script>
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import { EventCardElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-card-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "EventImage",
  extends: BaseImageElement,
  elementPanelSettings: {
    displayIcon: "image",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Image",
  },
  mixins: [EventCardElementMixin, FallbackImageElementMixin],
  computed: {
    imageSrc() {
      return this.entity.image;
    },
  },
};
</script>
